const meta = {
  id:          'custom',
  name:        'Custom',
  shortName:   'Custom',
  description: 'Custom system — build your own sheet',
  iconId:      'system.custom',
  order:       2,
};

export default meta;
